import type { Asset } from '@/types';
import { isTokenVerified } from '../hooks/use-token-verified.js';

type FuseSortFnArg = {
  idx: number;
  item: Asset;
  score: number;
};

export function sortFuseResult(a: FuseSortFnArg, b: FuseSortFnArg): 1 | -1 {
  const aVerified = isTokenVerified(a.item);
  const bVerified = isTokenVerified(b.item);

  if (!aVerified || !bVerified) {
    return aVerified ? -1 : 1;
  }

  if (a.score === b.score) {
    return a.idx < b.idx ? -1 : 1;
  }

  return a.score < b.score ? -1 : 1;
}
